import React from 'react';
import { observer, inject } from 'mobx-react';
import classNames from 'classnames';
import { toJS, action } from 'mobx';
import { Button, Modal, Table, Collapse, Radio, Row, Col, Icon, Input, message, Spin, Empty, Pagination, Popconfirm } from 'antd';
import Search from './Search';

const Panel = Collapse.Panel;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

@inject('ecodeGenreStore')
@observer
export default class Main extends React.Component {

  static defaultProps = {
    prefixCls: 'ecode-genre',
  }

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { ecodeGenreStore: { getGenreList } } = this.props;
    getGenreList()
  }

  modify = (name, id, type = 'genreId') => {
    const { ecodeGenreStore: { modify } } = this.props;
    const params = {
      name: name,
      [type]: id,
    }
    modify(params);
  }

  onCancel = () => {
    const { ecodeGenreStore: { setState, initEdit } } = this.props;
    initEdit();
    setState({visible: false});
  }

  onOk = () => {
    const { ecodeGenreStore } = this.props;
    const { editTitle, setState, initEdit, editValue, saveEditValue } = ecodeGenreStore;
    if(!editTitle) return;
    if(editValue === '') {
      message.info("名称不能为空");
    } else if(saveEditValue !== '' && saveEditValue === editValue) {
      message.info("名称未修改");
    } else {
      ecodeGenreStore[editTitle]().then(() => {
        setState({visible: false});
      });
      initEdit();
    }
  }

  pageChange = (pageNum, pageSize) => {
    const { ecodeGenreStore: { setState, getGenreList } } = this.props
    setState({pageNum, pageSize});
    getGenreList();
  }
  
  render() {
    const { 
      ecodeGenreStore: { genreList, deleteGenre, loadingRes, getColumns, visible, setState, editTitle, editValue,
         getFunctionList, functionList, activeKey, genreCount, pageSize, pageNum, editID },
      prefixCls 
    } = this.props;
    const columns = getColumns();
    const editTitleObj = {
      genre_add: '添加行业',
      func_add: '添加职能',
      genre_edit: '编辑行业',
      func_edit: '编辑职能',
    }
    const editTitleLabel = {
      genre_add: '',
      func_add: '行业',
      genre_edit: '行业',
      func_edit: '职能',
    }
    return (
      <div className={prefixCls}>
        <Search />
        <Spin spinning={loadingRes}>
          {
            genreList && genreList.length > 0 ? 
            <div>
              <Collapse
                style={{ marginTop: 5 }}
                activeKey={activeKey}
                accordion
                onChange={(e) => {
                  e && getFunctionList({tredeId: e});
                  setState({ activeKey: e });
                }}
                expandIconPosition="right"
                className={`${prefixCls}-body`}
                destroyInactivePanel
              >
                {
                  genreList && genreList.length > 0 && genreList.map((genreItem, index) => {
                    return (
                      <Panel
                        key={genreItem.g_id}
                        header={(
                          <Row>
                            <Col span={8}><span className={`${prefixCls}-body-title text-elli`} title={`行业：${genreItem.g_name}`}>行业：{genreItem.g_name}</span></Col>
                            <Col span={16}>
                              <span className={`${prefixCls}-body-title text-elli`} title={`ID：${genreItem.g_id}`}>
                                ID：{genreItem.g_id}
                              </span>
                            </Col>
                          </Row>
                        )}
                        className={`${prefixCls}-body-panel`}
                        extra={[
                          <Icon
                            type="setting"
                            className={`${prefixCls}-body-panel-icon`}
                            onClick={event => {
                              setState({visible: true, editTitle: 'genre_edit', editID: genreItem.g_id, editValue: genreItem.g_name, saveEditValue: genreItem.g_name});
                              event.stopPropagation();
                            }}
                          />,
                          <Popconfirm title="是否确定删除？"
                            okText="确定"
                            cancelText="取消"
                            onConfirm={() => {
                              deleteGenre({generId: genreItem.g_id})
                            }}
                          >
                            <Icon
                              type="close-circle"
                              className={`${prefixCls}-body-panel-icon`}
                              onClick={event => {
                                event.stopPropagation();
                                // deleteGenre({generId: genreItem.g_id});
                              }}
                            />
                          </Popconfirm>
                          // <Icon
                          //   type="close-circle"
                          //   className={`${prefixCls}-body-panel-icon`}
                          //   onClick={event => {
                          //     deleteGenre({generId: genreItem.g_id});
                          //     event.stopPropagation();
                          //   }}
                          // />
                        ]}
                      >
                        <Button
                          className={`${prefixCls}-body-btn`}
                          onClick={() => {
                            setState({visible: true, editTitle: 'func_add', editID: genreItem.g_id });
                          }}
                        >添加职能</Button>
                        <Table
                          rowKey="g_id"
                          dataSource={functionList}
                          columns={columns}
                          pagination={false}
                          className={`list-table order-list-table`}
                        />
                      </Panel>
                    )
                  })
                  
                }
              </Collapse>
              <Pagination
                total={genreCount}
                showQuickJumper
                showSizeChanger
                current={pageNum}
                pageSize={pageSize}
                onShowSizeChange={this.pageChange}
                onChange={this.pageChange}
                className={`${prefixCls}-pagination`}
              />
            </div>
            : !loadingRes && <Empty className={`${prefixCls}-body-btn`}/>
          }
        </Spin>
        <Modal
            title={editTitleObj[editTitle] || "添加行业"}
            className={`${prefixCls}-modal`}
            visible={visible}
            onCancel={this.onCancel}
            bodyStyle={{ height: 150 }}
            footer={[
              (<Button onClick={this.onCancel} key={`${prefixCls}cancel`}>返回</Button>),
              (<Button onClick={this.onOk} type="primary" key={`${prefixCls}ok`}>确定</Button>)
            ]}
          >
            {
              editID ? 
              <Row>
                <Col span={6} className={`${prefixCls}-modal-lable`}>
                  {`${editTitleLabel[editTitle] ? editTitleLabel[editTitle] : ''}ID：`}
                </Col>
                <Col span={18} style={{padding: '5px'}}>
                  <span>{editID}</span>
                </Col>
              </Row>
              : null
            }
            <Row>
              <Col span={6} className={`${prefixCls}-modal-lable`}>
                {`${editTitleLabel[editTitle] ? editTitleLabel[editTitle] : ''}名称：`}
              </Col>
              <Col span={18}>
                <Input value={editValue} onChange={e => setState({editValue: e.target.value})}/>
              </Col>
            </Row>
          </Modal>
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/sys/ecodeGenre/index.js